import { Component, OnInit, Injector, ChangeDetectorRef } from "@angular/core";
import { TableAbstractComponent } from "../../../../common-page-components/classes/table-abstract-component";
import { ResultsAthleteFiltersService } from "../../services/results-athlete-filters.service";
import { AthleteResultsStore } from "../../../../common-page-components/stores/entities-store/athlete-results-store";
import { HttpClient } from "@angular/common/http";
import { filter, tap,  map, mergeMap } from "rxjs/operators";
import { combineLatest, of, BehaviorSubject } from 'rxjs'
import { IHeaderConfig } from 'src/app/common-page-components/headers-component/headers-component.component';
import { IAthleteBiography } from '../../../../common-page-components/stores/entities-store/athlete-biography-store';
import {animate, style, transition, trigger} from '@angular/animations';
import { animationsTable } from '../../../../common-page-components/wa-table/wa-table.component';
import { FiltersAthleteGeneralService } from '../../../services/filters-athlete-general.service';
import { AthleteCategoriesCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';

@Component({
  selector: "app-boostrap-athlete-results",
  templateUrl: "./boostrap-athlete-results.component.html",
  styleUrls: ["./boostrap-athlete-results.component.scss"],
  animations: animationsTable,
  providers:[ResultsAthleteFiltersService]
})
export class BoostrapAthleteResultsComponent extends TableAbstractComponent
  implements OnInit {
  /**
   * The headers of this table
   *
   * @type {Array<IHeaderConfig>}
   * @memberof BootstraAthleteMatchesComponent
   */
  headers: Array<IHeaderConfig> = [
    { name: "", isSortable: false, sortProperty: "" },// Event photo column
    { name: "Name", isSortable:true, sortProperty:"NAME" },
    { name: "Date", isSortable: true, sortProperty: "DATE" },
    /*{ name: "Score", isSortable:true, sortProperty: "QSCORE"

    },*/
    { name: "Seed", isSortable:true, sortProperty: "QRANKING"

    },

    { name: "Ranking", isSortable: true, sortProperty: "RANKING" },
    { name: "" } // Plus column

  ];

  /**
   * Variable for contain the id of the athlete view
   *
   * @type {string}
   * @memberof BoostrapAthleteResultsComponent
   */
  idOfSelfAthlete: string;

  /**
   * Variable for set the index of selected team and view the details
   *
   * @type {number}
   * @memberof BoostrapAthleteResultsComponent
   */
  innerTableIndex:number;

    /**
   * The filters of the matches page.
   *
   * @memberof BoostrapAthleteResultsComponent
   */
  filterInfo;

  /**
   * The categories combo.
   *
   * @type {AthleteCategoriesCombo}
   * @memberof BootstraAthleteMatchesComponent
   */
  categoriesCombo: AthleteCategoriesCombo = new AthleteCategoriesCombo('Categories:', 'category-athlete', [], this.http_self, false);

  /**
   * The subject for advise that the combo has been changed after the routers go back.
   *
   * @type {BehaviorSubject<AthleteCategoriesCombo>}
   * @memberof BootstraAthleteMatchesComponent
   */
  categoriesComboSubject: BehaviorSubject<AthleteCategoriesCombo> = new BehaviorSubject(this.categoriesCombo);


  constructor(
    injector: Injector,
    http: HttpClient,
    public results_service: ResultsAthleteFiltersService,
    public common_service: FiltersAthleteGeneralService,
    private http_self: HttpClient,
    private chg:ChangeDetectorRef
  ) {
    super(injector, results_service, new AthleteResultsStore(http));
  }

  /**
   * A method for check if the route should be reused.
   *
   * @returns
   * @memberof BoostrapAthleteResultsComponent
   */
  shouldReuse(){
    return this.idOfSelfAthlete != undefined;
  }

  ngOnInit() {

    this.subscriptions.push(
      this.common_service.storedId.pipe(
        filter(a => a != undefined),
        mergeMap(a => {

          return this.common_service.athleteDetailStore.requestData({ Id: a, Detailed: 1 }, false);;
        }),
        map(a => a.items[0].AthleteCategories),
        tap(a => {
          // The combo doesn't update the reference so we listen to the last id of athlete.
          const comboData = a
          .filter(item=> item.IndividualTeam === 1)
          .map((value, i) => { return { item: value, position: i } });          // Update the combo in the general service.
          this.common_service.athleteCategoriesCombo = new AthleteCategoriesCombo('Categories:', 'category-athlete', comboData, this.http_self, false);
          // Se the new reference to combo.
          this.categoriesCombo = new AthleteCategoriesCombo('Categories:', 'category-athlete', comboData, this.http_self, false);
          // Push the new reference to the subject.
          this.categoriesComboSubject.next(this.categoriesCombo);
          // Update the filter info for the update of view.
          this.filterInfo = [
            this.results_service.textFilter.filterInfo,
            this.categoriesCombo ? this.categoriesCombo.filterInfo : undefined,
            this.results_service.podiumsCombo.filterInfo,
            this.results_service.eventTypeCombo.filterInfo,
            this.results_service.rangeDate.filterInfo
          ].filter(Boolean);
          // Call change detector reference for force check detection.
          this.chg.detectChanges();
        })
      ).subscribe(),
      combineLatest(
        this.results_service.common_service.storedId
        .asObservable()
        .pipe(
          filter(a => a != null),
          tap(a => (this.idOfSelfAthlete = a))
        ),
        this.reload.asObservable(),
        this.results_service.textFilter.data(),
        this.results_service.rangeDate.comboData,
        this.categoriesComboSubject.asObservable().pipe(mergeMap(a => a.comboData)),
        this.results_service.eventTypeCombo.comboData,
        this.results_service.orderValue,
        this.results_service.podiumsCombo.comboData
      ).pipe(
        map(([Id, reload, text, date_range, category, eventType, order, podium]) => {
            const params = {
              Id: Id.toString(),
              SortBy: order.sortingSend,
              Detailed:1,
              ParticipationCatCode:category ? category.Cat : undefined,
              fText:text.text,
              IndividualTeam:eventType.Value,
              RankMax:podium.Value === true ? 3 : undefined,
              StartDate: date_range.date_from
              ? String(
                  new Date(
                    date_range.date_from.getTime() -
                    date_range.date_from.getTimezoneOffset() * 60000
                  )
                    .toISOString()
                    .slice(0, 10)
                )
              : undefined,
            EndDate: date_range.date_to
              ? String(
                  new Date(
                    date_range.date_to.getTime() - date_range.date_to.getTimezoneOffset() * 60000
                  )
                    .toISOString()
                    .slice(0, 10)
                )
              : undefined
            };
            return params;
          }),
          filter(params => params.ParticipationCatCode != undefined),
          mergeMap(params =>
            this.model.requestData(params, this.request_more_data)
          )
        )
        .subscribe(next => {})
    );
  }

  /**
   * A getter for get the athlete from common service
   *
   * @returns {IAthleteBiography}
   * @memberof BoostrapAthleteResultsComponent
   */
  get getSelfAthlete():IAthleteBiography{
    return this.results_service.common_service.athleteDetailStore.data[0];
  }

}
